export default function Footer() {
  return (
    <div
      style={{
        boxShadow: "0px -3px 8px #00000012",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        fontFamily: '"Montserrat", sans-serif !important',
      }}
    >
      <div className="container pt-5 pb-2">
        <div className="desktop">
          <div className="row">
            <div className="col-md-4">
              <div>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingBottom: "24px",
                  }}
                >
                  Menu
                </h4>
                <a href="/#about">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    About Us
                  </p>
                </a>
                <a href="/#apply">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    How to Apply
                  </p>
                </a>
                <a href="/#feature">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Features
                  </p>
                </a>
                {/*<a href="#partners"><p style="font-size:16px; color:#777777; margin-bottom:8px;">Our Partners</p></a>*/}
                <a href="/#testimonial">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Testimonials
                  </p>
                </a>
                <a href="/#why-loan">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Why GetCredit
                  </p>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingBottom: "24px",
                  }}
                >
                  Important Links
                </h4>
                <a href="/contact-us">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Contact Us
                  </p>
                </a>
                <a href="/privacy-policy">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Privacy Policy
                  </p>
                </a>
                <a href="/terms-conditions">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Terms &amp; Conditions
                  </p>
                </a>
                <a href="terms-use">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Terms of Use
                  </p>
                </a>
                <div>
                  <a
                    href="https://www.facebook.com/GetCredit/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="assets/footer/facebook.svg" alt="facebook" />
                  </a>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="assets/footer/instagram.svg" alt="instagram" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div style={{ textAlign: "justify" }}>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingBottom: "24px",
                  }}
                >
                  Contact Us
                </h4>
                <p
                  style={{
                    fontSize: "15px",
                    color: "#777777",
                    marginBottom: "8px",
                  }}
                >
                  Loan tark HSG. Sty. Ltd ., Shop No.10, Building No.10,
                  Kamgarnagar 400024 Kurla East, Maharashtra, India{" "}
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    color: "#777777",
                    marginBottom: "8px",
                    marginTop: "45px",
                    textAlign: "left",
                  }}
                >
                  Mail: contact@GetCredit.org{" "}
                </p>
                {/*<p style="font-size:16px; color:#777777; margin-bottom:8px; margin-top: 45px; text-align:left;">Phone: 8585883226 </p>*/}
              </div>
            </div>
          </div>
          <hr style={{}} />
          <p
            style={{
              fontSize: "16px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Copyright 2021 <span style={{ color: "#39927E" }}>GetCredit</span>{" "}
            All rights reserved.
          </p>
        </div>
        <div className="mobile">
          <div className="row">
            <div className="col-12">
              <div className="text-center">
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingBottom: "24px",
                  }}
                  className="pb-0"
                >
                  Menu
                </h4>
                <a href="/#about">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    About Us
                  </p>
                </a>
                <a href="/#apply">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    How to Apply
                  </p>
                </a>
                <a href="/#feature">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Features
                  </p>
                </a>
                {/*<a href="#partners"><p style="font-size:16px; color:#777777; margin-bottom:8px;">Our Partners</p></a>*/}
                <a href="/#testimonial">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Testimonials
                  </p>
                </a>
                <a href="/#why-loan">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Why GetCredit
                  </p>
                </a>
              </div>
            </div>
            <div className="col-12 mt-2">
              <div className="text-center">
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingBottom: "24px",
                  }}
                >
                  Important Links
                </h4>
                <a href="/contact-us">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Contact Us
                  </p>
                </a>
                <a href="/privacy-policy">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Privacy Policy
                  </p>
                </a>
                <a href="/terms-conditions">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Terms &amp; Conditions
                  </p>
                </a>
                <a href="/terms-use">
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#777777",
                      marginBottom: "8px",
                    }}
                  >
                    Terms of Use
                  </p>
                </a>
                <div>
                  <a
                    href="https://www.facebook.com/GetCredit/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="assets/img/facebook.svg" alt="" />
                  </a>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="assets/img/instagram.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 text-center mt-4">
              <div style={{ textAlign: "center" }}>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    paddingBottom: "24px",
                    textAlign: "center",
                  }}
                  className="pb-0"
                >
                  Contact Us
                </h4>
                <p
                  style={{
                    fontSize: "16px",
                    color: "#777777",
                    marginBottom: "8px",
                  }}
                >
                  Loan tark HSG. Sty. Ltd ., Shop No.10, Building No.10,
                  Kamgarnagar 400024 Kurla East, Maharashtra, India
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    color: "#777777",
                    marginBottom: "8px",
                    marginTop: "45px",
                    textAlign: "center",
                  }}
                >
                  Mail: contact@GetCredit.org{" "}
                </p>
                {/*<p style="font-size:16px; color:#777777; margin-bottom:8px; margin-top: 45px; text-align:left;">Phone: 8585883226 </p>*/}
              </div>
            </div>
          </div>
          {/*</div>*/}
          <hr style={{}} />
          <p
            style={{
              fontSize: "16px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Copyright 2021 <span style={{ color: "#39927E" }}>GetCredit</span>{" "}
            All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
